import AES from '@ali/aes-tracker';
import AESPluginJSError from '@ali/aes-tracker-plugin-jserror';
import AESPluginAPI from '@ali/aes-tracker-plugin-api';
import AESPluginResourceError from '@ali/aes-tracker-plugin-resourceError';
import AESPluginPerf from '@ali/aes-tracker-plugin-perf';
import AESPluginEventTiming from '@ali/aes-tracker-plugin-eventTiming';
import AESPluginPV from '@ali/aes-tracker-plugin-pv';
import AESPluginLongTask from '@ali/aes-tracker-plugin-longtask';
import AESPluginBlank from '@ali/aes-tracker-plugin-blank';
import AESPluginAnimFluency from '@ali/aes-tracker-plugin-animFluency';
import AESPluginAutolog from '@ali/aes-tracker-plugin-autolog';
import AESPluginEmogine from '@ali/aes-tracker-plugin-emogine';

function safeParseJson(string) {
  let result = string;
  try {
    result = JSON.parse(string);
  } catch (error) {
    result = {};
  }
  return result || {};
}

function getQueryStringByName(name: string) {
  const { href } = window.location;
  const params = new URLSearchParams(new URL(href).search);
  const searchParams = {};
  for (let [key, value] of params) {
    searchParams[key] = value;
  }
  if (searchParams[name]) return searchParams[name];
  return '';
}

// 插件
const plugins = [
  AESPluginAutolog,
  AESPluginResourceError,
  AESPluginJSError,
  AESPluginAPI,
  AESPluginEventTiming,
  AESPluginEmogine,
  AESPluginBlank,
  AESPluginLongTask,
  AESPluginAnimFluency,
  AESPluginPV,
  AESPluginPerf,
];

const channelCode = getQueryStringByName('wapid');

// 环境变量中的API地址
const AEM_ENV = process.env.ICE_EXE_ENV || 'production';
const isPushLog = ['pre', 'uat', 'release', 'production'].includes(AEM_ENV);
const isDevEnvironment = () => process.env.NODE_ENV === 'development';

const localStorage = window.localStorage.getItem(`${channelCode}_baseObj`) || '{}';
const localStorageJson = safeParseJson(localStorage) || {};
const accountId = localStorageJson?.state?.baseObj?.user?.account?.accountId;
const canvasId = window.localStorage.getItem(`${channelCode}_canvasId`);

const config = {
  pid: isPushLog ? 'zbYSi2' : '',
  user_type: '101',
  uid: accountId || canvasId,
  env: process.env.ICE_EXE_ENV || 'production',
  version: process.env.ICE_APP_VERSION || 'unknown',
};

export const { sendError } = new AES(config).use(AESPluginJSError);

export default () => {
  // 本地开发环境不上报
  if (isDevEnvironment()) {
    return;
  }
  window.addEventListener(
    'error',
    (e) => {
      if (!(e instanceof ErrorEvent)) {
        let r = (e as any).target,
          t = r.src || r.href;
        if (!t || -1 !== t.indexOf('.mmstat.com')) return;
        let AES_QUEUE = (window as any).AES_QUEUE || [];

        AES_QUEUE.push({
          action: 'log',
          arguments: [
            'resource_error',
            {
              p1: t.substring(0, 1e3),
              p2: r.tagName.toLowerCase(),
              ts: new Date().getTime(),
            },
          ],
        });
      }
    },
    !0,
  );
  const aes = new AES(config);
  // 挂载插件
  aes.use(plugins);
  // 将插件实例按照1.x的命名挂载到window上，因为各个插件的方法都没有调整，这样可以保证业务代码中有使用1.x方法的地方可以正常运行
  (window as any).AESPluginPV = aes.use(AESPluginPV, {
    enableHistory: true,
  });
  (window as any).pref = aes.use(AESPluginPerf);
};
